import { Observable as ApolloObservable } from '@apollo/client'
import { Observable as RxObservable } from 'rxjs'

export const fromApolloObservable = <T>(observable: ApolloObservable<T>): RxObservable<T> =>
  new RxObservable<T>((subscriber) => observable.subscribe(subscriber))

export const toApolloObservable = <T>(observable: RxObservable<T>): ApolloObservable<T> =>
  new ApolloObservable<T>((subscriber) => observable.subscribe(subscriber))
